import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CircularProgress,
  Avatar,
  Dialog,
  IconButton,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import VideoPlayer from "./VideoPlayer"; // Import the VideoPlayer component


import LoadingScreenBlackLogo from "../../common/LoadingProgressBar";
import { fetchMoreVideoHomeComponents } from "../../apiservices/ApiService";


const CategoriesScreen = ({ typeId, type,displayName, onBack }) => {
  const [cards, setCategoryCards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleClosePlayer = () => {
    setSelectedVideo(null);
  };

  useEffect(() => {
    const loadCategoryVideos = async () => {
      setIsLoading(true);
      try {
        const data = await fetchMoreVideoHomeComponents({ typeId, type });
        if (data?.cards) {
          setCategoryCards(data.cards);
        }
      } catch (error) {
        console.error("Error fetching category videos:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadCategoryVideos();
  }, [typeId, type]);

  const handleVideoClick = (videoData) => {
    setSelectedVideo(videoData);
  };

  const fixUrlProtocol = (url) => {
    if (!url) return '';
    return url.startsWith('http:') ? url.replace(/^http:/, 'https:') : url;
  };
  const renderCard = (card) => (
    <Box sx={{ marginBottom: 4 }}>
      {card.cardMetaData?.title && (
        <Typography variant="h6" sx={{ marginBottom: 2 }}>
          {card.cardMetaData.title}
        </Typography>
      )}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {card.cardData.map((item, idx) => (
          <Card
            key={idx}
            onClick={() => handleVideoClick(item.data)}
            sx={{
              position: "relative",
              borderRadius: 2,
              overflow: "hidden",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              cursor: "pointer",
            }}
          >
            <CardMedia
              component="img"
              image={item.data.thumbnail}
              alt={item.data.title}
              sx={{ height: 180, objectFit: "cover" }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: 10,
                left: 10,
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                color: "white",
                padding: "2px 8px",
                borderRadius: 4,
              }}
            >
              {item.data.duration_display}
            </Box>
            <CardContent>
              <Typography variant="body1" fontWeight="bold">
                {item.data.title}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Avatar src={item.data.streamerImageUrl} alt={item.data.streamerName} />
                <Typography variant="body2">{item.data.streamerName}</Typography>
                <Typography variant="body2" sx={{ marginLeft: "auto" }}>
                  👁 {item.data.view_count_display} • ❤️ {item.data.like_count_display} • 💬{" "}
                  {item.data.comment_count_display}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );

  return (
    <>
    
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "10px 16px",
        backgroundColor: "#fff",
        borderBottom: "1px solid #ddd",
      }}
    >
      <ArrowBackIosIcon sx={{ cursor: "pointer" }} onClick={onBack} />
      <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center" }}>
        {displayName}
      </Typography>
    </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "10px 16px",
          backgroundColor: "#fff",
          borderBottom: "1px solid #ddd",
        }}
      >
       
      </Box>
      <Box sx={{ backgroundColor: "#f0f0f0", padding: 2 }}>
        {cards.map((card, idx) => (
          <Box key={idx}>{renderCard(card)}</Box>
        ))}
        {isLoading && (
          <LoadingScreenBlackLogo/>
        )}
      </Box>
      {selectedVideo && (
        <Dialog open fullScreen onClose={handleClosePlayer}>

<VideoPlayer
  videoSrc={fixUrlProtocol(selectedVideo?.downloadUrl)}
  onClose={handleClosePlayer}
  title={selectedVideo?.title}
/>

         </Dialog>
      )}
    </>
  );
};

export default CategoriesScreen;